export const Yield = (value: any): IteratorYieldResult<any> => { return { value: value, done: false } };